// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/plugins/manualColumnMove/manualColumnMove.css
// module id = 488
// module chunks = 0